import { FC, useContext } from "react";
import { DashboardContext } from "../DashboardContext";
import TeamManageCard from "./components/TeamManageCard";

const CaptainTeamPage: FC = () => {
  const { myTeam } = useContext(DashboardContext);

  if (myTeam) {
    return (
      <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full text-white overflow-y-auto mt-16">
        <div className="w-full max-w-3xl">
          <TeamManageCard myTeam={myTeam} />
        </div>
      </div>
    );
  } else {
    return <h1 className="text-white">You are currently not part of a team</h1>;
  }
};

export default CaptainTeamPage;
